import { render } from "./Cover.vue?vue&type=template&id=2ceabbbe&scoped=true&ts=true"
import script from "./Cover.vue?vue&type=script&lang=ts"
export * from "./Cover.vue?vue&type=script&lang=ts"

import "./Cover.vue?vue&type=style&index=0&id=2ceabbbe&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ceabbbe"]])

export default __exports__